export default "__VITE_ASSET__Daz6ifMC__$_?nuxt_component=async&nuxt_component_name=SvgoCommonNoDataSearch&nuxt_component_export=default__"